import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import { useEffect } from "react";

export function useUnauthenticated(redirectTo = "/planner") {
  const session = useSession();
  const router = useRouter();

  useEffect(() => {
    if (session.status === "authenticated") {
      void router.replace(redirectTo);
    }
  }, [redirectTo, router, session.status]);

  return {
    ...session,
    isLoading: session.status === "loading",
  };
}
